import axios from "axios";
import store from "../store";
import router from "../router";

let Api = axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT
});
//baseURL: "http://test2.loc/api"
//baseURL: "http://app.menubyte.loc/api"
//baseURL: "https://app.menubyte.it/api"


Api.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data

  return response;
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  if(error.response.status === 401 && error.response.data.message === "Unauthenticated."){
    
    store.dispatch("logout");
    router.push({ name: "Login"}); 

  }

  return Promise.reject(error);

});



Api.defaults.withCredentials = true;

export default Api;